import styled from 'styled-components'

import theme from '../../theme'
import { ScreenBreakpoints } from '../../theme'

const ButtonContainer = styled.span<{ isSelected?: boolean }>`
  button {
    text-shadow: none;
    box-shadow: none;
    cursor: pointer;
    background: ${({ isSelected }) => (isSelected ? theme.colors.white : 'transparent')};
    color: ${theme.colors.gray7};
    border-radius: 6px;
    font-weight: ${(props) => (props.isSelected ? theme.fontWeights.semiBold : theme.fontWeights.normal)};
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid transparent;
    box-shadow: ${({ isSelected }) =>
      isSelected ? '0px 1px 3px rgba(0, 0, 0, 0.08), 0px 1px 2px rgba(0, 0, 0, 0.04)' : 'none'};

    span {
      margin-left: 9px;
    }

    &:hover {
      background: ${theme.colors.lightBackground};
    }

    &:after {
      animation: none;
    }
  }

  .ant-btn:hover,
  .ant-btn:focus {
    color: ${theme.colors.gray7};
    border-color: transparent;
    background: ${({ isSelected }) => (isSelected ? theme.colors.white : 'transparent')};
  }

  @media (min-width: ${ScreenBreakpoints.medium}px) and (max-width: ${ScreenBreakpoints.large}px) {
    button {
      background: ${({ isSelected }) => (isSelected ? theme.colors.white : theme.colors.lightBackground)};
    }

    .ant-btn:hover,
    .ant-btn:focus {
      color: ${theme.colors.gray7};
      background: ${({ isSelected }) => (isSelected ? theme.colors.white : theme.colors.lightBackground)};
    }
  }
`

export { ButtonContainer }
